__turbopack_context__.v({
  "className": "ranga_d24af946-module__snGAma__className",
});
